import fr from './locales/read-only-auto-generated/fr.json';
import en from './locales/read-only-auto-generated/en.json';

type localeDataType = {
  fr: Record<string, string>;
  en: Record<string, string>;
};
type LocaleType = 'fr' | 'en';
const localeData: localeDataType = { fr, en };

export function getLocalByCountry(country: Window['COUNTRY_CODE']): LocaleType {
  if (country === 'uk') return 'en';
  return country;
}

export const getLocalMessages = (
  locale: LocaleType,
): Record<string, string> => {
  const messages: Record<string, string> = localeData[locale] || localeData.fr;

  return messages;
};
